import { symmetricEncrypt, symmetricdecrypt } from './crypto';

const QB_USER = 'qbuser';

export const getToken = () => {
    const value = localStorage.getItem(QB_USER);
    if (value === null) return null;
    return JSON.parse(symmetricdecrypt(value));
};

export const setToken = (value) => {
    const encValue = symmetricEncrypt(JSON.stringify(value));
    localStorage.setItem(QB_USER, encValue);
};

export const deleteToken = () => {
    localStorage.removeItem(QB_USER);
};

export default {
    getToken,
    setToken,
    deleteToken,
};
